module.exports = __webpack_public_path__ + "media/images/scribe-unlisted-9b865714.png";